import { FunctionOpenInNewTab } from "radium-omnibus";
import React from "react";
import { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { GoogleMapMain } from "../../components/googleMap/GoogleMap.Main";
import IconInfoWithModalMain from "../../components/IconInfoWithModal/IconInfoWithModal.Main";
import Container from "../../components/layouts/Container";
import WrapperMiddleScreen from "../../components/layouts/WrapperMiddleScreen";
import { ContextLanguage } from "../../context/Context.Language";
import {
  ON_DAILY_BASIS,
  TEXT_ACOUNT_BOLD_TERM,
  TEXT_ALLTHE_TERM,
  TEXT_ANY_ORDER_UNCLAIMED,
  TEXT_AS_A_RESULT_TERM,
  TEXT_AS_A_RESULT_TERM_2,
  TEXT_AS_LONG_AS,
  TEXT_BY_USING_TERM,
  TEXT_COLLECTION_AND_RETURN,
  TEXT_CUSTOMER_ACCOUNT_TERM,
  TEXT_CUSTOMER_SHALL,
  TEXT_HAVE_TO,
  TEXT_HIGH_QULITY,
  TEXT_IF_OU_USE_TERM,
  TEXT_INCLUDING_TERM,
  TEXT_IN_ORDER_TERM,
  TEXT_IN_ORDER_TERM_2,
  TEXT_IRONING_TERM,
  TEXT_LIABILITY_TERM,
  TEXT_MYLAUNDRY_BAG,
  TEXT_MY_LAUNDRY,
  TEXT_MY_LAUNDRY_PROVIDE_TERM,
  TEXT_OFFERING_QUALITY_TERM,
  TEXT_ORDER_PROCESS_TERM,
  TEXT_PROVIDED_THAT,
  TEXT_SHOES_CLEANING_TERM,
  TEXT_SUCH_TERM,
  TEXT_SUITABILITY_TERM,
  TEXT_TERM_10,
  TEXT_TERM_11,
  TEXT_TERM_11_1,
  TEXT_TERM_11_2,
  TEXT_TERM_11_2_2,
  TEXT_TERM_12,
  TEXT_TERM_12_1,
  TEXT_TERM_12_2,
  TEXT_TERM_12_2_2,
  TEXT_TERM_12_2_3,
  TEXT_TERM_13,
  TEXT_TERM_13_1,
  TEXT_TERM_13_2,
  TEXT_TERM_13_3,
  TEXT_TERM_1_3,
  TEXT_TERM_1_3_1,
  TEXT_TERM_1_3_2,
  TEXT_TERM_3_1,
  TEXT_TERM_3_3,
  TEXT_TERM_3_3_1,
  TEXT_TERM_3_3_2,
  TEXT_TERM_3_3_3,
  TEXT_TERM_3_3_3_1,
  TEXT_TERM_3_3_3_2,
  TEXT_TERM_3_3_3_3,
  TEXT_TERM_3_3_3_4,
  TEXT_TERM_3_3_4,
  TEXT_TERM_5_5_1,
  TEXT_TERM_5_5_2,
  TEXT_TERM_5_5_3,
  TEXT_TERM_5_5_4,
  TEXT_TERM_6,
  TEXT_TERM_7_7_1,
  TEXT_TERM_7_7_2_MY_LAUNDRY_TO_PROCESS,
  TEXT_TERM_7_7_2_STANDARDS,
  TEXT_TERM_7_7_3,
  TEXT_TERM_7_7_4,
  TEXT_TERM_7_7_4_2,
  TEXT_TERM_7_7_5,
  TEXT_TERM_7_7_6,
  TEXT_TERM_7_7_6_2,
  TEXT_TERM_7_7_7,
  TEXT_TERM_8,
  TEXT_TERM_8_1,
  TEXT_TERM_8_2,
  TEXT_TERM_8_2_2,
  TEXT_TERM_8_3,
  TEXT_TERM_9,
  TEXT_TERM_9_1,
  TEXT_TERM_9_2,
  TEXT_TERM_AND_CONDITION,
  TEXT_THESE_TERMS,
  TEXT_THE_BAG_CAN_STILL_BE_TERM,
  TEXT_THE_CUSTOMER_AGREES_TERM,
  TEXT_THE_CUSTOMER_CAN_PLACE,
  TEXT_THE_CUSTOMER_SHALL_TERM,
  TEXT_THE_FOLLOWINF_TERM,
  TEXT_THE_FOLLOWING_NEWLINE,
  TEXT_THE_MAINTAIN_TERM,
  TEXT_WEBSITE_INCLUDING_TERM,
  TEXT_WEBSITE_SEMIBOLD,
  TEXT_WHEN_MAKING_YOUR_FIRST_TERM,
  TEXT_YOU_ARE_RESPONSIBLE_FOR,
} from "../../utils/useConstants";
import { ICON_CHEVRON_LEFT } from "../../utils/useIcons";
import { useIsMobile } from "../../utils/useIsMobile";
import {
  STYLE_ADDRESS_BG,
  STYLE_BUTTON_ICON_LEFT,
  STYLE_CONTAINER_NO_PADDING_READ,
  STYLE_HOVER_BLUE,
  STYLE_ICON_INFO_HOME,
  STYLE_LINK_BLUE,
  STYLE_LINK_BLUE_NO_MX,
  STYLE_MAX_WIDTH_DESKTOP,
  STYLE_MIN_H_FULL,
  STYLE_PADDING_WINDOWS,
  STYLE_PROGRAM_BACK,
  STYLE_SUBTITLE_SEMIBOLD,
  STYLE_SUB_NO_TERM,
  STYLE_TEXT_DETAIL,
  STYLE_TITLE_TEARM_POLICY,
  STYLE_TITLE_TEARM_POLICY_MB,
  STYLE_UNDERLINE_BLUE_TERM,
} from "../../utils/useStyle";
import ProgramClickBack from "../task/functions/Program.ClickBack";
import ProgramGoBack from "../task/render/Program.GoBack";
import { TermFirstLoad } from "./functions/Term.FirstLoad";
import MetaTags from "../../utils/useMetaTags";

const TermMain = () => {
  React.useEffect(() => {
    TermFirstLoad();
  }, []);
  const { language } = React.useContext(ContextLanguage);
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  return (
    <div id="scroll_term" className="">
      {language === "TH" ? (
        <MetaTags
          title="ข้อกำหนดและเงื่อนไข ¬- กรุงเทพ | My Laundry"
          description="My Laundry ดูแลทุกการซักรีดและซักรองเท้าอย่างมืออาชีพ ตั้งแต่การสั่งออเดอร์ออนไลน์จนส่งถึงหน้าบ้านคุณ รายละเอียดเพิ่มเติมที่ ข้อกำหนดและเงื่อนไข!"
        />
      ) : (
        <MetaTags
          title="Terms & Conditions - Bangkok | My Laundry"
          description="My Laundry provides professional laundry & shoe cleaning services, from placing an order on our website until its completion. Learn more about our T&Cs!"
        />
      )}

      <Container style={`${STYLE_CONTAINER_NO_PADDING_READ} `}>
        <div className={`${STYLE_MAX_WIDTH_DESKTOP} md:px-10 xl:px-37 mx-auto`}>
          <div
            className={`bg-white  md:ordershadow px-4 md:px-6 md:pb-[30px] md:rounded-xl h-full relative ${STYLE_MIN_H_FULL} `}
          >
            {/* <div
              className={`flex md:grid grid-cols-6 ${STYLE_PROGRAM_BACK(
                language
              )}`}
            >
              <ICON_CHEVRON_LEFT
                className={STYLE_BUTTON_ICON_LEFT}
                onClick={() => {
                  ProgramClickBack(navigate);
                }}
              />
              <div className=" mx-auto md:col-span-4">
                {isMobile ? (
                  <div className={STYLE_TITLE_TEARM_POLICY_MB(language)}>
                    {TEXT_TERM_AND_CONDITION[language]}
                  </div>
                ) : (
                  <IconInfoWithModalMain
                    classNameWrapper={STYLE_TITLE_TEARM_POLICY(language)}
                    title={TEXT_TERM_AND_CONDITION[language]}
                    classNameIcon={`${STYLE_ICON_INFO_HOME} ${STYLE_HOVER_BLUE} `}
                    showIconInfo={false}
                  />
                )}
              </div>
            </div> */}
            <ProgramGoBack
              marginarrow="md:ml-[130px]"
              // onClick={() => {
              //   navigate(-1);
              // }}
              title={TEXT_TERM_AND_CONDITION[language]}
              textcolor={`${
                language === "TH"
                  ? " text-xl-th md:text-28-th w-fit "
                  : " ttext-xl md:text-28 w-fit "
              } `}
            />
            <div className=" block md:grid md:grid-cols-2 gap-4 md:gap-[68px] ">
              <div
                className={`${STYLE_TEXT_DETAIL(language)} ${
                  language === "EN" && "leading-5"
                } `}
              >
                <div className="">
                  {/* {TEXT_MY_LAUNDRY_PROVIDE_TERM[language]} */}
                  {language === "TH" ? (
                    <span>
                      My Laundry ให้บริการซักรีด รีดผ้า ทำความสะอาดรองเท้า
                      และบริการจัดส่งน้ำดื่มอย่างมืออาชีพ ("
                      <span className="font-bold">บริการ</span>")
                      ให้แก่ลูกค้าโดยใช้เว็บไซต์
                    </span>
                  ) : (
                    <span>
                      My Laundry provides professional laundry, ironing, shoe
                      cleaning, and water delivery ("
                      <span className="font-bold">Services</span>") to our
                      customers using our website
                    </span>
                  )}
                  {/* <span
                    onClick={() => {
                      FunctionOpenInNewTab("https://www.mylaundrythai.com");
                    }}
                    className={`${STYLE_LINK_BLUE} w-fit`}
                  >
                    www.mylaundrythai.com
                  </span> */}
                  <span className={` w-fit mx-1`}>www.mylaundrythai.com</span>
                  ("
                  <span className="font-semibold">
                    {TEXT_WEBSITE_SEMIBOLD[language]}
                  </span>
                  ")
                  {TEXT_WEBSITE_INCLUDING_TERM[language]}{" "}
                  {TEXT_OFFERING_QUALITY_TERM[language]}
                  <div className={`${STYLE_TEXT_DETAIL(language)} `}>
                    {/* {TEXT_THE_FOLLOWING_NEWLINE[language]} */}
                    {language === "TH" ? (
                      <span>
                        ข้อกำหนดและเงื่อนไขต่อไปนี้ ("
                        <span className="font-bold">ข้อกำหนด</span>")
                        จะครอบคลุมการใช้บริการของเรา
                        เมื่อสั่งบริการของเราจะถือว่าท่านรับทราบและยอมรับข้อกำหนด
                      </span>
                    ) : (
                      <span>
                        The following terms and conditions ("
                        <span className="font-bold">Terms</span>
                        ") govern the use of our Services. By placing an order
                        for our Services, you acknowledge and accept the Terms.
                      </span>
                    )}
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)} `}>
                    {TEXT_THE_FOLLOWINF_TERM[language]}
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)} `}>
                    {TEXT_THESE_TERMS[language]}
                  </div>
                  <div className={`${STYLE_SUBTITLE_SEMIBOLD(language)} my-3`}>
                    1. {TEXT_CUSTOMER_ACCOUNT_TERM[language]}
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)} `}>
                    <span className="font-semibold">1.1</span>{" "}
                    {TEXT_IN_ORDER_TERM[language]} ("
                    <span className="font-bold">
                      {TEXT_ACOUNT_BOLD_TERM[language]}
                    </span>
                    "). <div>{TEXT_IN_ORDER_TERM_2[language]}</div>
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)} `}>
                    <span className="font-semibold">1.2</span>{" "}
                    {TEXT_THE_CUSTOMER_AGREES_TERM[language]}
                    {TEXT_THE_MAINTAIN_TERM[language]}
                    {TEXT_THE_CUSTOMER_SHALL_TERM[language]}
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)} `}>
                    <span className="font-semibold">1.3</span>{" "}
                    {/* {TEXT_TERM_1_3[language]}  */}
                    {language === "TH" ? (
                      <span>
                        My Laundry เคารพความเป็นส่วนตัวของลูกค้า
                        และจะปฏิบัติตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ.
                        2562 รวมถึงระเบียบและประกาศดังกล่าว ("
                        <span className="font-bold">กฎหมาย</span>") My Laundry
                        ได้จัดทำ
                        <span
                          onClick={() => {
                            navigate("/PrivacyNotice");
                          }}
                          className={STYLE_LINK_BLUE}
                        >
                          ประกาศความเป็นส่วนตัว
                        </span>
                        สำหรับลูกค้าเกี่ยวกับข้อกำหนดและการปฏิบัติตามกฎหมาย
                      </span>
                    ) : (
                      <span>
                        My Laundry respects the privacy of our Customers and
                        shall comply with the Persona Data Protection Act B.E.
                        2562 (2019) including the regulations and announcements
                        thereof ("<span className="font-bold">Laws</span>"). My
                        Laundry has provided a{" "}
                        <span
                          onClick={() => {
                            navigate("/PrivacyNotice");
                          }}
                          className={STYLE_LINK_BLUE_NO_MX}
                        >
                          Privacy Notice
                        </span>{" "}
                        for our Customers regarding the legal requirements and
                        our compliance therewith to ensure that
                      </span>
                    )}
                    {TEXT_ALLTHE_TERM[language]}
                    {TEXT_TERM_1_3_1[language]}
                    {/* {TEXT_SUCH_TERM[language]} */}
                    {TEXT_TERM_1_3_2[language]}
                  </div>
                  <div className={`${STYLE_SUBTITLE_SEMIBOLD(language)} my-3`}>
                    2. {TEXT_SUITABILITY_TERM[language]}
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)} `}>
                    {TEXT_BY_USING_TERM[language]}
                  </div>
                  <div className={`${STYLE_SUBTITLE_SEMIBOLD(language)} my-3`}>
                    3. {TEXT_ORDER_PROCESS_TERM[language]}
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                    <span className="font-semibold">3.1</span>{" "}
                    {TEXT_TERM_3_1[language]}
                    <div className={STYLE_SUB_NO_TERM}>
                      (1.) {TEXT_TERM_3_3_1[language]}
                    </div>
                    <div className={STYLE_SUB_NO_TERM}>
                      (2.) {TEXT_TERM_3_3_2[language]}
                    </div>
                    <div className={STYLE_SUB_NO_TERM}>
                      (3.) {TEXT_TERM_3_3_3[language]}
                    </div>
                    <div className={STYLE_SUB_NO_TERM}>
                      (4.) {TEXT_TERM_3_3_4[language]}
                    </div>
                  </div>
                  {TEXT_CUSTOMER_SHALL[language]}
                  <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                    <span className="font-semibold">3.2</span>{" "}
                    {TEXT_WHEN_MAKING_YOUR_FIRST_TERM[language]}("
                    <span className="font-bold">
                      {TEXT_MYLAUNDRY_BAG[language]}
                    </span>
                    "){language === "EN" && ""}
                    {language === "TH"
                      ? " ยกเว้นลูกค้าที่เลือกบริการแขวน หรือแขวนพิเศษ"
                      : " except for customers who have chosen the Hang or Hang Plus+ options."}
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                    {language === "TH"
                      ? "หากใช้ถุงใส่ผ้ามายลอนดรี้ในการสั่งบริการ จะไม่มีการนับจำนวนชิ้น ถุงใส่ผ้ามายลอนดรี้สามารถใช้ได้กับบริการซัก-พับเท่านั้นและจำกัดปริมาณสูงสุด 2 ถุงใส่ผ้ามายลอนดรี้ต่อหนึ่งออเดอร์ ราคาจริงต่อหนึ่งถุงใส่ผ้ามายลอนดรี้ (ณ วันที่ 15 กรกฎาคม 2566: 595 บาท) และสองถุงใส่ผ้ามายลอนดรี้ (ณ วันที่ 15 กรกฎาคม 2566: 1,045 บาท) ซึ่งสามารถดูได้ในเว็บไซต์ของเรา หากใช้ถุงอื่นใส่ผ้าในการสั่งบริการ คุณสามารถใส่ผ้าได้ไม่เกินจำนวนที่คุณเลือกบนเว็บไซต์ของเรา"
                      : "If you use a My Laundry Bag for your orders, the number of items is not counted. The My Laundry Bag concepts applies to the Wash & Fold Service only and is limited to a maximum of 2 x My Laundry Bags per order. The actual pricing for 1 x My Laundry Bag (as of 15.07.2023: 595 THB) and 2 x My Laundry Bags (as of 15.07.2023: 1045 THB) can be seen on our website. If you use any other bag for your laundry orders, you can put in no more than the number of items you have selected on our website. "}
                    {/* {TEXT_IF_OU_USE_TERM[language]} */}
                    {/* {TEXT_AS_LONG_AS[language]} */}
                    {/* {TEXT_THE_BAG_CAN_STILL_BE_TERM[language]} */}
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                    <span className="font-semibold">3.3</span>{" "}
                    {TEXT_TERM_3_3[language]}
                    <div className={STYLE_SUB_NO_TERM}>
                      {language === "EN" ? "(i) " : "(1.) "}{" "}
                      {TEXT_TERM_3_3_3_1[language]}
                    </div>
                    <div className={STYLE_SUB_NO_TERM}>
                      {language === "EN" ? "(ii) " : "(2.) "}
                      {TEXT_TERM_3_3_3_2[language]}
                    </div>
                    <div className={STYLE_SUB_NO_TERM}>
                      {language === "EN" ? "(iii) " : "(3.) "}
                      {TEXT_TERM_3_3_3_3[language]}
                    </div>
                    <div className={STYLE_SUB_NO_TERM}>
                      {language === "EN" ? "(iv) " : "(4.) "}
                      {TEXT_TERM_3_3_3_4[language]}
                    </div>
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                    <span className="font-semibold">3.4</span>{" "}
                    {TEXT_YOU_ARE_RESPONSIBLE_FOR[language]}
                  </div>
                  <div className={`${STYLE_SUBTITLE_SEMIBOLD(language)} my-3`}>
                    4. {TEXT_COLLECTION_AND_RETURN[language]}
                  </div>
                  {TEXT_THE_CUSTOMER_CAN_PLACE[language]}
                  <div className={`${STYLE_SUBTITLE_SEMIBOLD(language)} my-3`}>
                    5. {TEXT_IRONING_TERM[language]}
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                    <span className="font-semibold">5.1</span>{" "}
                    {TEXT_TERM_5_5_1[language]}
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                    <span className="font-semibold">5.2</span>{" "}
                    {TEXT_TERM_5_5_2[language]}
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                    <span className="font-semibold">5.3</span>{" "}
                    {TEXT_TERM_5_5_3[language]}
                  </div>
                  <div className={` ${STYLE_TEXT_DETAIL(language)} `}>
                    <span className="font-semibold">5.4</span>{" "}
                    {TEXT_TERM_5_5_4[language]}
                  </div>
                </div>
              </div>

              <div
                className={`${STYLE_TEXT_DETAIL(language)} ${
                  language === "EN" && "leading-5"
                } `}
              >
                <div>
                  <div className={`${STYLE_SUBTITLE_SEMIBOLD(language)} mb-3`}>
                    6. {TEXT_SHOES_CLEANING_TERM[language]}
                  </div>
                  {TEXT_TERM_6[language]}
                  <div className={`${STYLE_SUBTITLE_SEMIBOLD(language)} my-3`}>
                    7. {TEXT_LIABILITY_TERM[language]}
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                    <span className="font-semibold">7.1</span>{" "}
                    {TEXT_TERM_7_7_1[language]}
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                    <span className="font-semibold">7.2</span>{" "}
                    {TEXT_TERM_7_7_2_MY_LAUNDRY_TO_PROCESS[language]}
                    {TEXT_HIGH_QULITY[language]}
                    {TEXT_TERM_7_7_2_STANDARDS[language]}
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                    <span className="font-semibold">7.3</span>{" "}
                    {TEXT_TERM_7_7_3[language]}
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                    <span className="font-semibold">7.4</span>{" "}
                    {TEXT_TERM_7_7_4[language]}
                    {TEXT_AS_A_RESULT_TERM[language]}
                    {TEXT_TERM_7_7_4_2[language]}
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                    <span className="font-semibold">7.5</span>{" "}
                    {TEXT_TERM_7_7_5[language]}
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                    <span className="font-semibold">7.6</span>{" "}
                    {TEXT_TERM_7_7_6[language]}
                    {TEXT_AS_A_RESULT_TERM_2[language]}
                    {TEXT_TERM_7_7_6_2[language]}
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                    <span className="font-semibold">7.7</span>{" "}
                    {TEXT_TERM_7_7_7[language]}
                  </div>
                  <div className={`${STYLE_SUBTITLE_SEMIBOLD(language)} my-3`}>
                    8. {TEXT_TERM_8[language]}
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                    <span className="font-semibold">8.1</span>{" "}
                    {TEXT_TERM_8_1[language]}
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                    <span className="font-semibold">8.2</span>{" "}
                    {TEXT_TERM_8_2[language]}
                    {TEXT_AS_A_RESULT_TERM_2[language]}
                    {TEXT_TERM_8_2_2[language]}
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                    <span className="font-semibold">8.3</span>{" "}
                    {TEXT_TERM_8_3[language]}
                  </div>
                  <div className={`${STYLE_SUBTITLE_SEMIBOLD(language)} my-3`}>
                    9. {TEXT_TERM_9[language]}
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                    <span className="font-semibold">9.1</span>{" "}
                    {TEXT_TERM_9_1[language]}
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                    <span className="font-semibold">9.2</span>{" "}
                    {TEXT_TERM_9_2[language]}
                  </div>
                  <div className={`${STYLE_SUBTITLE_SEMIBOLD(language)} my-3`}>
                    10. {TEXT_TERM_10[language]}
                  </div>
                  {TEXT_ANY_ORDER_UNCLAIMED[language]}
                  <div className={`${STYLE_SUBTITLE_SEMIBOLD(language)} my-3`}>
                    11. {TEXT_TERM_11[language]}
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                    <span className="font-semibold">11.1</span>{" "}
                    {TEXT_TERM_11_1[language]}
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                    <span className="font-semibold">11.2</span>{" "}
                    {TEXT_TERM_11_2[language]}
                    {ON_DAILY_BASIS[language]}
                    {TEXT_TERM_11_2_2[language]}
                  </div>
                  <div className={`${STYLE_SUBTITLE_SEMIBOLD(language)} my-3`}>
                    12. {TEXT_TERM_12[language]}
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                    <span className="font-semibold">12.1</span>{" "}
                    {TEXT_TERM_12_1[language]}
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                    <span className="font-semibold">12.2</span>{" "}
                    {TEXT_TERM_12_2[language]}
                    {TEXT_HAVE_TO[language]}
                    {TEXT_TERM_12_2_2[language]}
                    {TEXT_PROVIDED_THAT[language]}
                    {TEXT_TERM_12_2_3[language]}
                  </div>
                  <div className={`${STYLE_SUBTITLE_SEMIBOLD(language)} my-3`}>
                    13. {TEXT_TERM_13[language]}
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                    <span className="font-semibold">13.1</span>{" "}
                    {TEXT_TERM_13_1[language]}
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                    <span className="font-semibold">13.2</span>{" "}
                    {TEXT_TERM_13_2[language]}
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                    <span className="font-semibold">13.3</span>{" "}
                    {TEXT_TERM_13_3[language]}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default TermMain;
